export const SPACING = {
  page: "space-y-24 py-24",
  section: "space-y-16",
  content: "space-y-8",
  stack: "space-y-4"
} 